import axios from '@/utils/request'
// 获取品牌列表
export const subBrand = (params) => {
    return axios.request({
        url: 'v1/subBrand',
        method: 'get',
        params
    })
};
// 删除品牌
export const subBrandDel = (id) => {
    return axios.request({
        url: 'v1/subBrand/del/' + id,
        method: 'DELETE',
    })
};
// 添加品牌
export const brandCreate = (data) => {
    return axios.request({
        url: 'v1/subBrand/add',
        method: 'post',
        data
    })
};
// 修改品牌
export const brandUpdate = (data) => {
    return axios.request({
        url: 'v1/subBrand/update',
        method: 'post',
        data
    })
};